export const publicImageUrl = process.env.REACT_APP_API_BASE_URL + 'file?path=';
export const publicImageDownloadUrl = process.env.REACT_APP_API_BASE_URL + 'file-download?path=';